import { useCallback } from 'react';
import { selectRoom, selectUserAvatar } from 'state/selectors';
import { useCache } from 'useCase/cache/useCache';

export const parseParticipantMetadata = (metadata?: string) => {
    if (!metadata) {
        return {};
    }

    try {
        return JSON.parse(metadata);
    } catch (e) {
        console.error(e);
        return {};
    }
};

/** userId из participant metadata: только string/number, без blanket String() на сырых данных. */
export const getParticipantUserIdFromMetadata = (metadata?: string): string | null => {
    const userId = parseParticipantMetadata(metadata)?.userDetails?.userId;
    if (typeof userId === 'string') return userId;
    if (typeof userId === 'number' && Number.isFinite(userId)) return String(userId);
    return null;
};

export const getNameFromMetadata = (stringifiedMetadata?: string, defaultName = '') => {
    const { userDetails } = parseParticipantMetadata(stringifiedMetadata);

    const name = userDetails ? `${userDetails.userName}` : defaultName;

    return name;
};

export const useParticipantMetadata = () => {
    const { getCachedImage } = useCache();

    const broadcastParticipandAvatar = useCallback(() => {
        const room = selectRoom();
        const avatar = selectUserAvatar();

        if (!room || !avatar) return;

        try {
            const metadataString = room.localParticipant.metadata;
            if (metadataString) {
                const metadata = JSON.parse(metadataString);

                // Сохраняем аватар в метаданные пользователя
                room.localParticipant.setMetadata(
                    JSON.stringify({
                        ...metadata,
                        userDetails: {
                            ...metadata.userDetails,
                            avatar,
                        },
                    }),
                );
            }
        } catch (e) {
            console.log('Не удалось установить новый аватар');
        }
    }, []);

    const getAvatarFromMetadata = useCallback((stringifiedMetadata?: string) => {
        const { userDetails } = parseParticipantMetadata(stringifiedMetadata);

        if (!userDetails) return '';

        const { avatar } = userDetails;

        if (!avatar) return '';

        return getCachedImage(avatar);
    }, []);

    return {
        getNameFromMetadata,
        broadcastParticipandAvatar,
        getAvatarFromMetadata,
    };
};
